// receivableDetail.api.ts

import apiHandler from "../../../../api/core/apiHandler";

/**
 * Endpoint base:
 * /api/receivables/details
 */
const receivableDetailApi = apiHandler("receivables/details");

export default receivableDetailApi;